import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#69788A\" clip-path=\"url(#clip0_38_3478)\"><path d=\"m3.032 4.09 16.877 16.88c.29.29.77.29 1.06 0s.29-.77 0-1.06L4.093 3.03a.755.755 0 0 0-1.06 0c-.29.29-.29.77 0 1.06\"></path><path d=\"M4.092 20.97 20.97 4.1c.29-.29.29-.77 0-1.06a.755.755 0 0 0-1.06 0L3.032 19.91c-.29.29-.29.77 0 1.06s.77.29 1.06 0\"></path></g><defs><clipPath id=\"clip0_38_3478\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }